import React, { FC } from 'react';

import './styles.scss';

type Props = {
    alignLeft?: boolean;
    children: any;
    className?: string;
};

const SubNav: FC<Props> = ({ alignLeft = false, children, className = '' }) => (
    <div className={`sub-nav-container ${className} ${alignLeft ? 'align-left' : ''}`}>{children}</div>
);

export default SubNav;
